export default __webpack_public_path__ + "static/media/facebookGaming.142321f4.svg";